module.exports = __webpack_public_path__ + "img/largeloader_stopped.32af06dc.svg";